import template from './feedback_agent_notifications.html';

const feedbackAgent = {
  bindings: {
    contacts: '<',
    updateContacts: '<',
    disabled: '<',
  },
  controller: bbFeedbackAgentsCtrl,
  controllerAs: 'vm',
  template,
};

angular
  .module('bb.appointments.feedback')
  .component('bbFeedbackAgents', feedbackAgent);

bbFeedbackAgentsCtrl.$inject = ['$scope', 'userService'];

function bbFeedbackAgentsCtrl($scope, userService) {
  const vm = this;

  vm.$onChanges = function ({ contacts }) {
    const newContacts = contacts.currentValue;
    if (!newContacts) {
      vm.dataLoaded = false;
      return;
    }

    // Generate a map of toggle functions
    vm.toggleContact = newContacts.reduce((acc, contact) => {
      acc[contact.contactId] = () => {
        const updated = { ...contact };
        updated.notifications['Feedback Collected'] =
          !contact.notifications['Feedback Collected'];
        vm.updateContacts(updated);
      };
      return acc;
    }, {});

    // Unlike Client contacts (Seller, Landlord, Tenant), Agent contacts' names must be looked up.
    const agentContacts = newContacts.filter(
      contact => contact.type === 'Agent',
    );
    userService
      .getUserNames(
        agentContacts.map(c => c.contactId),
        'showingConfig',
      )
      .then(function (agentNames) {
        let agentContactIdx = 0;
        // Recombine the returned Agent names with the Client contacts whose names are known.
        // Agent names must be inserted in their original places as a lot of the display logic works by index.
        const names = newContacts.map(contact => {
          if (contact.type === 'Agent') {
            const contactName = agentNames[agentContactIdx];
            agentContactIdx += 1;
            return contactName;
          }
          return `${contact.firstName} ${contact.lastName}`;
        });

        $scope.$evalAsync(() => {
          vm.contactNames = names;
          vm.dataLoaded = true;
        });
      });
  };
}

export default feedbackAgent;
